export const SurchargesOptimizationsActionTypes = {
    API_RESPONSE_SUCCESS: '@@surcharges-optimizations/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@surcharges-optimizations/API_RESPONSE_ERROR',
    GET_SURCHARGES_NO_SURCHARGES: '@@surcharges-optimizations/GET_SURCHARGES_NO_SURCHARGES',
    GET_NO_NON_SHIPMENT_SURCHARGES: '@@surcharges-optimizations/GET_NO_NON_SHIPMENT_SURCHARGES',
    GET_NON_SHIPMENT_SURCHARGES_COST: '@@surcharges-optimizations/GET_NON_SHIPMENT_SURCHARGES_COST',
    GET_SURCHARGES_COST: '@@surcharges-optimizations/GET_SURCHARGES_COST',
    GET_AUDITABLE_SURCHARGES_COST: '@@surcharges-optimizations/GET_AUDITABLE_SURCHARGES_COST',
    GET_COMPARISON_SURCHARGES_COST: '@@surcharges-optimizations/GET_COMPARISON_SURCHARGES_COST',
    GET_COMPARISON_ANALYTICS_RECORDS: '@@surcharges-optimizations/GET_COMPARISON_ANALYTICS_RECORDS',
};
